import { useTexture } from '@react-three/drei';
import * as THREE from "three";

import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import { Fog } from "three";

const path = "./data/Grass001_4K-JPG/Grass001_4K-JPG_";

export const Grass = () => {
  const [colorMap, normalMap, roughnessMap, displacementMap] = useTexture([
    path + 'Color.jpg',
path + 'NormalGL.jpg',
path + 'Roughness.jpg',
path + 'Displacement.jpg'

]);

// 🔹 Herhaal de textuur meer keren zodat het gras kleiner lijkt
const repeatFactor = 80; // Verander dit naar 20 of 30 als het nog te groot is
[colorMap, normalMap, roughnessMap, displacementMap].forEach((map) => {
  if (map) {
    map.wrapS = map.wrapT = THREE.RepeatWrapping;
    map.repeat.set(repeatFactor, repeatFactor);
  }
});


  return (
    <mesh receiveShadow rotation-x={-Math.PI / 2} position={[0, -1.61, 0]}>
      <circleGeometry args={[15, 64]} />
      <meshStandardMaterial
        map={colorMap}
        normalMap={normalMap}
        //roughnessMap={roughnessMap}
        displacementMap={displacementMap}
        displacementScale={-0.2}
        roughness={0.9}
        envMapIntensity={0.5}
      />
    </mesh>
  );
}

export const FogEffect = () => {
  return null; // Fog disabled
}